import Immutable from "immutable";
import { call, select, put, take } from "redux-saga/effects";
import { aggregateID } from "lib/id";

import {
  getPaymentByID,
  getPaymentInstallmentSelectedPrice,
  isPaymentsReady,
  getBasketItemsOfType
} from "state/school_money/selectors";
import {
  setBasketItem,
  deleteBasketItem,
  deleteBasketItemGroup
} from "state/school_money/actions";

import validateBasketItem from "state/school_money/sagas/basketSaga/payment/validateBasketItem";

export function* addInstallmentToBasket(action) {
  const { paymentID, installmentNumber } = action.payload;
  
  const payment = yield select(getPaymentByID, paymentID);
  const { schoolID, studentID } = payment.toObject();
  const basketItemID = aggregateID(paymentID, installmentNumber);
  const price = yield select(getPaymentInstallmentSelectedPrice, paymentID, installmentNumber);
  const payload = { paymentID, installmentNumber, payment };
  
  yield put(setBasketItem("payment", basketItemID, schoolID, studentID, paymentID, price, 1, payload));
  
}

export function* removeInstallmentFromBasket(action) {
  const { paymentID, installmentNumber } = action.payload;
  yield put(deleteBasketItem("payment", aggregateID(paymentID, installmentNumber)));
}

export function* removeFromBasket(action) {
  const { paymentID } = action.payload;
  yield put(deleteBasketItemGroup("payment", paymentID));
}

export function* detectBasketItemsIssues() {
  
  // wait for payments to be loaded
  while (!(yield select(isPaymentsReady))) {
    yield take();
  }
  
  // get relevant state
  const basketItems = yield select(getBasketItemsOfType, "payment");
  
  // build up a list of issues
  let issues = Immutable.List();
  for (const basketItem of basketItems) {
    const issue = yield call(validateBasketItem, basketItem);
    if (issue) {
      issues = issues.push(issue);
    }
  }
  
  return issues;
  
}

export function* resolveBasketItemsIssues(issues) {
  
  if (issues === undefined) {
    return;
  }
  
  // delete basket items that caused issues
  for (const issue of issues) {
    yield put(deleteBasketItem("payment", issue.get("basketItemID")));
  }
  
}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/basketSaga/payment/index.js